// frontend/src/services/api/authAPI.js
import api from "./config";

const authAPI = {
  register: async (userData) => {
    const response = await api.post("/auth/register", userData);
    return response;
  },

  verifyEmail: async (token) => {
    const response = await api.get(`/auth/verify-email/${token}`);
    return response;
  },

  login: async (credentials) => {
    const response = await api.post("/auth/login", credentials);
    return response;
  },

  refreshToken: async (refreshToken) => {
    const response = await api.post("/auth/refresh-token", { refreshToken });
    return response;
  },
};

export default authAPI;
